import { render, staticRenderFns } from "./ConfigurationSettingDetail.vue?vue&type=template&id=2fb48ee2&scoped=true"
import script from "./ConfigurationSettingDetail.vue?vue&type=script&lang=js"
export * from "./ConfigurationSettingDetail.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationSettingDetail.vue?vue&type=style&index=0&id=2fb48ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb48ee2",
  null
  
)

export default component.exports